module.exports = __webpack_public_path__ + "img/image39.8413dd7b.png";